import {
    UNITS_CREATE_REQUEST,
    UNITS_CREATE_ERROR,
    UNITS_CREATE_SUCCESS,
} from 'state/actions/unit_create'

const initialState = {
    inProgress: false,
    errorMessage: '',
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case UNITS_CREATE_REQUEST: {
        return {
            ...state,
            inProgress: true,
            errorMessage: '',
        }
    }
    case UNITS_CREATE_ERROR: {
        return {
            ...state,
            inProgress: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case UNITS_CREATE_SUCCESS: {
        return {
            ...state,
            inProgress: false,
            errorMessage: '',
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/unit_create.js